import "./App.css";
import Header from "./components/Header";
import Commonplace from "./components/Commonplace";
import KnowledgeLists from "./components/KnowledgeLists";
import Landing from "./components/Landing";
import Footer from "./components/common/Footer";

import {
  Container,
  Typography,
  Link,
  Card,
  Box,
  Button,
  Paper,
} from "@mui/material";

import { useState } from "react";
import { useSession } from "@inrupt/solid-ui-react";

// https://www.freecodecamp.org/news/create-a-solid-to-do-app-with-react/

// https://github.com/inrupt/solid-ui-react-demo/blob/main/components/profile/index.jsx

//TODO: can user have multiple stores?  Like a local store and a cloud store under the same username?  -- use multiple sessionProviders?
//https://solid.github.io/solid-oidc/#concepts-webids
//TODO: solid loses auth on refresh page https://docs.inrupt.com/developer-tools/javascript/client-libraries/tutorial/restore-session-browser-refresh/#session-restore-upon-browser-refresh
//TODO: app clientId or bot access?  How does this multiple schemas work?  https://forum.solidproject.org/t/registering-client-id-for-client-app/5646
//TODO: Web App dataset URI to env variable
function App() {
  const { session } = useSession();
  const [showLanding, setShowLanding] = useState(true);
  const [showCommonplace, setShowCommonplace] = useState(false);
  const [showKnowledgeLists, setShowKnowledgeLists] = useState(false);
  const [listsToDisplay, setListsToDisplay] = useState();

  const handleShowCommonplace = () => {
    setShowLanding(false);
    setShowCommonplace(true);
    setShowKnowledgeLists(false);
  };

  const handleShowKnowledgeLists = () => {
    setShowLanding(false);
    setShowKnowledgeLists(true);
    setShowCommonplace(false);
  };

  const handleShowLanding = () => {
    setShowLanding(true);
    setShowCommonplace(false);
    setShowKnowledgeLists(false);
  };

  const handleListsToDisplay = (quoteObjectArray) => {
    setListsToDisplay(quoteObjectArray);
  };

  return (
    <Container className="landing-container" maxWidth={false}>
      {showLanding && (
        <Landing
          handleShowCommonplace={handleShowCommonplace}
          handleShowKnowledgeLists={handleShowKnowledgeLists}
          currentView="landing"
        />
      )}
      {showCommonplace && (
        <Commonplace
          handleShowLanding={handleShowLanding}
          handleShowKnowledgeLists={handleShowKnowledgeLists}
          sessionActive={session.info.isLoggedIn}
          listsToDisplay={listsToDisplay}
          handleListsToDisplay={handleListsToDisplay}
          currentView="commonplace"
        />
      )}
      {showKnowledgeLists && (
        <KnowledgeLists
          handleShowLanding={handleShowLanding}
          handleShowCommonplace={handleShowCommonplace}
          listsToDisplay={listsToDisplay}
          handleListsToDisplay={handleListsToDisplay}
          currentView="knowledgeLists"
        />
      )}
      {/* <hr />
      <Container className="get-involved" style={{ margin: 25 }}>
        <p>
          Affiliated with the work at <a href="https://kwaai.ai/">Kwaai Labs</a>
        </p>
      </Container> */}
      <Footer />
    </Container>
  );
}

export default App;
